(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-desktop-shop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-desktop-shop')) {
    customElements.define('rc-desktop-shop', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.rc-shop-nav__trigger');
        this.panel = this.querySelector('.rc-shop-panel');
        if (!this.button || !this.panel) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        document.body.append(this.panel);
        this.position = () => {
          const header = document.querySelector('#header-component');
          const bottom = header?.getBoundingClientRect().bottom || this.getBoundingClientRect().bottom;
          const categoryNav = document.querySelector('.ruido-catnav');
          const categoryBottom = categoryNav?.getBoundingClientRect().bottom || 0;
          const top = Math.max(0, bottom, categoryBottom);
          this.panel.style.setProperty('--rc-shop-top', `${top}px`);
        };
        this.close = (restoreFocus = false) => {
          this.panel.hidden = true;
          this.openedByHover = false;
          this.button.setAttribute('aria-expanded', 'false');
          if (restoreFocus) this.button.focus();
        };
        const open = () => {
          if (!matchMedia('(min-width: 750px)').matches) return;
          this.position();
          this.panel.hidden = false;
          this.button.setAttribute('aria-expanded', 'true');
        };
        this.button.addEventListener('click', () => {
          if (this.openedByHover) { this.openedByHover = false; return; }
          this.panel.hidden ? open() : this.close();
        }, options);
        this.button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && this.panel.hidden) { open(); this.openedByHover = true; } }, options);
        this.panel.querySelector('.rc-shop-panel__close').addEventListener('click', () => this.close(true), options);
        this.querySelectorAll('nav > a').forEach(link => link.addEventListener('pointerenter', () => this.close(), options));
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target) && !this.panel.contains(event.target)) this.close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.panel.hidden) this.close(true);
          if (event.key === 'Tab' && !this.panel.hidden && document.activeElement === this.button && !event.shiftKey) {
            event.preventDefault();
            this.panel.querySelector('button, a').focus();
          }
        }, options);
        document.addEventListener('focusin', event => {
          if (!this.contains(event.target) && !this.panel.contains(event.target)) this.close();
        }, options);
        this.panel.addEventListener('keydown', event => {
          const lastLink = this.panel.querySelector('.rc-shop-panel__footer a');
          if (event.key === 'Tab' && !event.shiftKey && event.target === lastLink) {
            event.preventDefault();
            this.close();
            this.querySelector('nav > a').focus();
          }
          if (event.key === 'Tab' && event.shiftKey && event.target === this.panel.querySelector('button')) {
            event.preventDefault();
            this.button.focus();
          }
        }, options);
        window.addEventListener('resize', () => {
          if (!matchMedia('(min-width: 750px)').matches) this.close();
          else if (!this.panel.hidden) this.position();
        }, options);
        document.addEventListener('scroll', () => { if (!this.panel.hidden) this.position(); }, { ...options, passive: true, capture: true });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.panel?.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ruido-fit-line"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ruido-fit-line')) {
    customElements.define('ruido-fit-line', class extends HTMLElement {
      connectedCallback() {
        this.mobile = matchMedia('(max-width: 749px)');
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fit());
        };
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) {
            this.lastWidth = width;
            this.schedule();
          }
        });
        this.observer.observe(this);
        this.mobile.addEventListener('change', this.schedule);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.schedule();
        });
        this.schedule();
      }
      fit() {
        const text = this.querySelector('[data-fit-content]');
        if (!text || !this.clientWidth) return;
        const max = Number(this.mobile.matches ? this.dataset.fitMaxMobile : this.dataset.fitMax) || 12;
        this.style.setProperty('--ruido-fit-font', max + 'px');
        const width = text.getBoundingClientRect().width;
        const size = width > this.clientWidth ? max * (this.clientWidth - 1) / width : max;
        this.style.setProperty('--ruido-fit-font', size + 'px');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.schedule);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
